import React, { useState, useEffect, useRef } from "react";
import { User, CreditCard, Shield, Bell, Key, LogOut, Check, X, Copy, Terminal, Trash2, Plus } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";
import axios from "axios";
import { API_BASE_URL } from "../config";

export default function SettingsPage() {
  const { user, logout } = useAuth();
  const [activeTab, setActiveTab] = useState("account");

  return (
    <div className="p-6 w-full mx-auto">
      <h1 className="text-2xl font-bold text-gray-800 mb-6">Settings</h1>

      <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
        {/* Tabs */}
        <div className="flex border-b border-gray-200">
          <button
            onClick={() => setActiveTab("account")}
            className={`px-6 py-4 text-sm font-medium flex items-center gap-2 transition-colors ${
              activeTab === "account"
                ? "text-brand-cta border-b-2 border-brand-cta bg-green-50/50"
                : "text-gray-600 hover:text-gray-900 hover:bg-gray-50"
            }`}
          >
            <User className="w-4 h-4" />
            Account
          </button>
          <button
            onClick={() => setActiveTab("billing")}
            className={`px-6 py-4 text-sm font-medium flex items-center gap-2 transition-colors ${
              activeTab === "billing"
                ? "text-brand-cta border-b-2 border-brand-cta bg-green-50/50"
                : "text-gray-600 hover:text-gray-900 hover:bg-gray-50"
            }`}
          >
            <CreditCard className="w-4 h-4" />
            Billing
          </button>
          <button
            onClick={() => setActiveTab("apikeys")}
            className={`px-6 py-4 text-sm font-medium flex items-center gap-2 transition-colors ${
              activeTab === "apikeys"
                ? "text-brand-cta border-b-2 border-brand-cta bg-green-50/50"
                : "text-gray-600 hover:text-gray-900 hover:bg-gray-50"
            }`}
          >
            <Terminal className="w-4 h-4" />
            API Keys
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          {activeTab === "account" && <AccountSettings user={user} />}
          {activeTab === "billing" && <BillingSettings user={user} />}
          {activeTab === "apikeys" && <APIKeysSettings />}
        </div>
      </div>
    </div>
  );
}

function AccountSettings({ user }) {
  return (
    <div className="space-y-8 max-w-xl">
      {/* Profile Section */}
      <section>
        <h3 className="text-lg font-semibold text-gray-800 mb-4">Profile Information</h3>
        <div className="flex flex-col items-start gap-6">
          <div className="relative group ">
            <div className="w-24 h-24 rounded-full bg-gray-200 flex items-center justify-center text-gray-400 overflow-hidden">
             {/* Mock Avatar */}
             <User className="w-12 h-12" />
            </div>
            <button className="absolute bottom-0 right-0 p-1.5 bg-brand-cta text-white rounded-full shadow-sm hover:bg-emerald-600 transition-colors">
              <span className="sr-only">Change Photo</span>
              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
            </button>
          </div>
          
          <div className="flex-1 space-y-4 w-full">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Full Name</label>
              <input 
                type="text" 
                defaultValue={user?.first_name ? `${user.first_name} ${user.last_name || ''}`.trim() : "User"} 
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-cta focus:border-brand-cta outline-none transition-all"
              />
            </div>
             <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Email Address</label>
              <input 
                type="email" 
                defaultValue={user?.email || ""} 
                readOnly
                className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-50 text-gray-500 cursor-not-allowed"
              />
            </div>
          </div>
        </div>
      </section>

      <hr className="border-gray-100" />

      {/* Password Section */}
      {/* <section>
        <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2">
          <Shield className="w-5 h-5 text-gray-500" />
          Security
        </h3>
        <div className="w-full space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Current Password</label>
            <input 
              type="password" 
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-cta focus:border-brand-cta outline-none transition-all"
              placeholder="••••••••"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">New Password</label>
            <input 
              type="password" 
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-cta focus:border-brand-cta outline-none transition-all"
              placeholder="••••••••"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Confirm New Password</label>
            <input 
              type="password" 
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-cta focus:border-brand-cta outline-none transition-all"
              placeholder="••••••••"
            />
          </div>
          <div className="pt-2">
            <button className="px-4 py-2 bg-gray-900 text-white rounded-lg hover:bg-gray-800 transition-colors font-medium text-sm">
              Update Password
            </button>
          </div>
        </div>
      </section> */}
    </div>
  );
}

function APIKeysSettings() {
  const [keys, setKeys] = useState([]);
  const [loading, setLoading] = useState(true);
  const [creating, setCreating] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [newKeyName, setNewKeyName] = useState("");
  const [createdKey, setCreatedKey] = useState(null);
  const [copied, setCopied] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    fetchKeys();
  }, []);

  useEffect(() => {
    if (showModal && inputRef.current) {
      inputRef.current.focus();
    }
  }, [showModal]);

  function authHeader() {
    const token = localStorage.getItem('token');
    return token ? { Authorization: `Bearer ${token}` } : {};
  }

  const fetchKeys = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/cli/v1/keys/`, { headers: authHeader() });
      setKeys(Array.isArray(response.data) ? response.data : []);
    } catch (err) {
      console.error("Failed to fetch API keys:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleGenerate = async (e) => {
    e.preventDefault();
    if (!newKeyName.trim()) return;
    setCreating(true);
    try {
      const response = await axios.post(`${API_BASE_URL}/cli/v1/keys/`, { name: newKeyName.trim() }, { headers: authHeader() });
      setCreatedKey(response.data);
      setNewKeyName("");
      fetchKeys();
    } catch (err) {
      console.error("Failed to create API key:", err);
    } finally {
      setCreating(false);
    }
  };

  const handleRevoke = async (keyId, keyName) => {
    if (!window.confirm(`Revoke key "${keyName}"? This cannot be undone.`)) return;
    try {
      await axios.delete(`${API_BASE_URL}/cli/v1/keys/${keyId}/`, { headers: authHeader() });
      setKeys((prev) => prev.filter((k) => k.id !== keyId));
    } catch (err) {
      console.error("Failed to revoke key:", err);
    }
  };

  const handleCopy = () => {
    if (!createdKey?.key) return;
    navigator.clipboard.writeText(createdKey.key).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setCreatedKey(null);
    setNewKeyName("");
    setCopied(false);
  };

  const formatRelativeTime = (dateStr) => {
    if (!dateStr) return "Never";
    const diff = Date.now() - new Date(dateStr).getTime();
    const minutes = Math.floor(diff / 60000);
    if (minutes < 1) return "Just now";
    if (minutes < 60) return `${minutes}m ago`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours}h ago`;
    return `${Math.floor(hours / 24)}d ago`;
  };

  return (
    <div className="space-y-6 max-w-3xl">
      <div>
        <h3 className="text-lg font-semibold text-gray-800 mb-1">API Keys</h3>
        <p className="text-sm text-gray-500">
          Generate API keys for the TraderBro CLI or AI agents. Keys give programmatic read-only access to your data.
        </p>
      </div>

      {/* Generate button */}
      <button
        onClick={() => setShowModal(true)}
        className="flex items-center gap-2 px-4 py-2 bg-brand-cta text-white rounded-lg text-sm font-medium hover:bg-emerald-600 transition-colors shadow-sm"
      >
        <Plus className="w-4 h-4" />
        Generate New Key
      </button>

      {/* Keys table */}
      <div className="overflow-hidden rounded-lg border border-gray-200">
        {loading ? (
          <div className="flex justify-center p-8">
            <div className="animate-spin rounded-full h-7 w-7 border-b-2 border-brand-cta" />
          </div>
        ) : keys.length === 0 ? (
          <div className="p-8 text-center text-sm text-gray-500">
            No API keys yet. Generate one to get started.
          </div>
        ) : (
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Key</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Last Used</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Created</th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Action</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {keys.map((k) => (
                <tr key={k.id}>
                  <td className="px-6 py-4 text-sm font-medium text-gray-900">{k.name}</td>
                  <td className="px-6 py-4 text-sm font-mono text-gray-500">{k.key_prefix}…</td>
                  <td className="px-6 py-4 text-sm text-gray-500">{formatRelativeTime(k.last_used_at)}</td>
                  <td className="px-6 py-4 text-sm text-gray-500">
                    {new Date(k.created_at).toLocaleDateString()}
                  </td>
                  <td className="px-6 py-4 text-right">
                    <button
                      onClick={() => handleRevoke(k.id, k.name)}
                      className="text-red-500 hover:text-red-700 transition-colors"
                      title="Revoke key"
                    >
                      <Trash2 className="w-4 h-4" />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* Setup hint */}
      <div className="bg-gray-50 rounded-lg p-4 border border-gray-200 text-sm text-gray-600 font-mono">
        traderbro configure --server https://traderbro.ai --key &lt;your-key&gt;
      </div>

      {/* Generate modal */}
      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
          <div className="bg-white rounded-xl shadow-xl w-full max-w-md mx-4 p-6">
            {!createdKey ? (
              <>
                <h4 className="text-lg font-semibold text-gray-800 mb-4">Generate New API Key</h4>
                <form onSubmit={handleGenerate} className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Key Name</label>
                    <input
                      ref={inputRef}
                      type="text"
                      value={newKeyName}
                      onChange={(e) => setNewKeyName(e.target.value)}
                      placeholder="e.g. My MacBook, OpenClaw Agent"
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-cta focus:border-brand-cta outline-none"
                    />
                  </div>
                  <div className="flex gap-3 pt-1">
                    <button
                      type="submit"
                      disabled={creating || !newKeyName.trim()}
                      className="flex-1 px-4 py-2 bg-brand-cta text-white rounded-lg font-medium text-sm hover:bg-emerald-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      {creating ? "Generating…" : "Generate Key"}
                    </button>
                    <button
                      type="button"
                      onClick={handleCloseModal}
                      className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg font-medium text-sm hover:bg-gray-50 transition-colors"
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </>
            ) : (
              <>
                <div className="flex items-start justify-between mb-4">
                  <h4 className="text-lg font-semibold text-gray-800">Key Generated</h4>
                  <button onClick={handleCloseModal} className="text-gray-400 hover:text-gray-600">
                    <X className="w-5 h-5" />
                  </button>
                </div>
                <div className="mb-4 p-3 bg-amber-50 border border-amber-200 rounded-lg text-sm text-amber-800 flex items-center gap-2">
                  <Key className="w-4 h-4 flex-shrink-0" />
                  Copy this key now. It will not be shown again.
                </div>
                <div className="flex items-center gap-2 mb-6">
                  <code className="flex-1 px-3 py-2 bg-gray-100 rounded-lg text-sm font-mono text-gray-800 break-all">
                    {createdKey.key}
                  </code>
                  <button
                    onClick={handleCopy}
                    className="p-2 text-gray-500 hover:text-brand-cta transition-colors flex-shrink-0"
                    title="Copy to clipboard"
                  >
                    {copied ? <Check className="w-4 h-4 text-brand-cta" /> : <Copy className="w-4 h-4" />}
                  </button>
                </div>
                <button
                  onClick={handleCloseModal}
                  className="w-full px-4 py-2 bg-gray-900 text-white rounded-lg font-medium text-sm hover:bg-gray-800 transition-colors"
                >
                  Done
                </button>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

function BillingSettings({ user }) {
  const [subscription, setSubscription] = useState(null);
  const [billingHistory, setBillingHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [cancelling, setCancelling] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [subResponse, historyResponse] = await Promise.all([
          axios.get(`${API_BASE_URL}/api/payments/subscription/manage/`),
          axios.get(`${API_BASE_URL}/api/payments/subscription/billing-info/`)
        ]);

        // Subscription Logic
        let activeSub = subResponse.data.find(sub => sub.status === 'active' || sub.status === 'trialing');
        if (!activeSub) {
           activeSub = subResponse.data.find(sub => sub.status === 'canceled' && new Date(sub.current_period_end) > new Date());
        }
        setSubscription(activeSub || null);

        // Billing History Logic
        setBillingHistory(historyResponse.data || []);

      } catch (error) {
        console.error("Failed to fetch data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleCancelSubscription = async () => {
    if (!subscription) return;
    
    if (!window.confirm("Are you sure you want to cancel your subscription? You will lose access to premium features at the end of your current billing period.")) {
      return;
    }

    setCancelling(true);
    try {
      const response = await axios.post(`${API_BASE_URL}/api/payments/subscription/manage/`, {
        event: "cancel",
        subscription_id: subscription.id,
        at_end_period: true
      });

      if (response.data.status === "canceled") {
        setSubscription(response.data.subscription);
      }
    } catch (error) {
      console.error("Failed to cancel subscription:", error);
      alert("Failed to cancel subscription. Please try again or contact support.");
    } finally {
      setCancelling(false);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center p-8">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-cta"></div>
      </div>
    );
  }

  const isPremium = !!subscription && (subscription.status === 'active' || subscription.status === 'trialing' || (subscription.status === 'canceled' && new Date(subscription.current_period_end) > new Date()));
  const isCanceled = subscription?.status === 'canceled' || subscription?.cancel_at_period_end;
  
  const planName = subscription ? subscription.plan.name : "Free Plan";
  const planPrice = subscription ? `${subscription.plan.currency.toUpperCase()} ${subscription.plan.price}` : "$0.00";
  const billingInterval = subscription ? subscription.plan.billing_interval : "";
  const nextBillingDate = subscription ? new Date(subscription.current_period_end).toLocaleDateString() : "";

  return (
    <div className="space-y-8">
      {/* Current Plan */}
      <section>
        <h3 className="text-lg font-semibold text-gray-800 mb-4">Subscription Plan</h3>
        <div className="bg-gray-50 rounded-xl p-6 border border-gray-200">
          <div className="flex items-center justify-between">
            <div>
              <div className="flex items-center gap-3 mb-2">
                <h4 className="text-xl font-bold text-gray-900">{planName}</h4>
                {isPremium ? (
                   <span className={`px-2.5 py-0.5 rounded-full text-xs font-medium flex items-center gap-1 ${isCanceled ? 'bg-yellow-100 text-yellow-800' : 'bg-emerald-100 text-emerald-800'}`}>
                     {isCanceled ? (
                       <>
                        <LogOut className="w-3 h-3" /> Canceling
                       </>
                     ) : (
                       <>
                        <Check className="w-3 h-3" /> Active
                       </>
                     )}
                   </span>
                ) : (
                  <span className="px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-200 text-gray-700">
                    Free
                  </span>
                )}
              </div>
              <p className="text-sm text-gray-600">
                {isPremium 
                  ? (isCanceled 
                      ? `Your subscription has been canceled and will end on ${nextBillingDate}.`
                      : `Billed ${billingInterval}. Next billing date: ${nextBillingDate}. Amount: ${planPrice}`)
                  : "Upgrade to unlock advanced features and unlimited access."}
              </p>
            </div>
             <div className="flex items-center gap-3">
               {!isPremium && !isCanceled ? (
                 <a 
                   href="/upgrade" 
                   className="px-5 py-2.5 bg-brand-cta text-white rounded-lg font-medium hover:bg-emerald-600 transition-colors shadow-sm shadow-brand-cta/20"
                 >
                   Upgrade Plan
                 </a>
               ) : null}
               
               {isPremium && !isCanceled && (
                 <button 
                  onClick={handleCancelSubscription}
                  disabled={cancelling}
                  className="px-4 py-2 border border-red-200 text-red-600 rounded-lg font-medium hover:bg-red-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                 >
                   {cancelling ? "Cancelling..." : "Cancel Subscription"}
                 </button>
               )}
             </div>
          </div>
        </div>
      </section>

      <hr className="border-gray-100" />

      {/* Billing History */}
      <section>
        <h3 className="text-lg font-semibold text-gray-800 mb-4">Billing History</h3>
        <div className="overflow-hidden rounded-lg border border-gray-200">
          {billingHistory.length > 0 ? (
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Amount</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Invoice</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {billingHistory.map((item) => (
                  <tr key={item.id}>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                      {new Date(item.created_at).toLocaleDateString()}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                      {item.currency.toUpperCase()} {item.total}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className={`px-2.5 py-0.5 rounded-full text-xs font-medium ${
                        item.status === 'paid' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'
                      }`}>
                        {item.status.charAt(0).toUpperCase() + item.status.slice(1)}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-right">
                      {item.invoice_pdf && (
                        <a 
                          href={item.invoice_pdf} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          className="text-brand-cta hover:text-emerald-700 font-medium hover:underline"
                        >
                          Download
                        </a>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className="p-8 text-center text-gray-500 text-sm">
              No billing history available.
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
